<script setup>
import { useDetectDevice } from '@/composables/device'

const { isMobile } = useDetectDevice()

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['update:modelValue'])
</script>
<template>
  <q-toggle
    :model-value="modelValue"
    checked-icon="mdi-format-list-bulleted-type"
    unchecked-icon="mdi-format-list-bulleted"
    color="primary"
    dense
    :label="isMobile ? $t(modelValue ? 'common.listing' : 'common.service') : undefined"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <q-tooltip>{{ $t('common.showListingFirst') }}</q-tooltip>
  </q-toggle>
</template>
